import {Directive, ElementRef, output} from "@angular/core";
import {fromEvent} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

/**
 * Håndterer klikk-event og forhindrer at eventet propagerer videre.
 * Bruk:
 * <button (click.stopp)="vedKlikk($event)">klikk meg</button>
 */
@Directive({
    selector: "[click.stopp]",
    standalone: true
})
export class KlikkMedStopPropagationDirektiv {

    emitter = output<any>({alias:'click.stopp'})

    constructor(elementRef:ElementRef) {
        fromEvent<MouseEvent>(elementRef.nativeElement, 'click', { capture: true })
          .pipe(takeUntilDestroyed())
          .subscribe(event => {
              event.stopPropagation();
              this.emitter.emit(event);
          });
    }
}
